(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sticky-atc"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const stickyAtc = document.getElementById('sticky-atc');
    const footer = document.getElementById('footer');

    if (!stickyAtc) return;

    // Main ATC button on the PDP — scoped to .product-buy-buttons so we don't match
    // the sticky bar itself, upsell modals, or product cards.
    const mainAtc = document.querySelector('.product-buy-buttons .btn-atc[name="add"]');

    // Without a main ATC to track, the "only show when main is hidden" rule has no anchor.
    // Keep sticky hidden rather than always showing.
    if (!mainAtc) return;

    let mainAtcScrolledPast = false;
    let footerOverlapping = false;

    function applyVisibility() {
      if (mainAtcScrolledPast && !footerOverlapping) {
        stickyAtc.classList.add('show');
      } else {
        stickyAtc.classList.remove('show');
      }
    }

    // Watch the main ATC. Sticky should appear only when the user has scrolled
    // past it (button above viewport) — NOT when it's still below the fold,
    // which would mean the user hasn't reached it yet.
    const atcObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            mainAtcScrolledPast = false;
          } else {
            // bottom < 0 → button is fully above the viewport (user scrolled past).
            // top > viewport height → button is below viewport (user hasn't scrolled to it yet).
            mainAtcScrolledPast = entry.boundingClientRect.bottom < 0;
          }
          applyVisibility();
        });
      },
      { threshold: 0 }
    );
    atcObserver.observe(mainAtc);

    // Footer-overlap prevention: hide sticky when the footer is about to collide with it.
    function checkFooterOverlap() {
      if (!footer) {
        footerOverlapping = false;
        applyVisibility();
        return;
      }
      const footerRect = footer.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const stickyAtcHeight = stickyAtc.offsetHeight;
      const buffer = 20; // match previous behavior

      footerOverlapping = footerRect.top < windowHeight - stickyAtcHeight - buffer;
      applyVisibility();
    }

    // Debounced scroll handler (50ms + rAF) — preserved from previous implementation
    // to prevent blink during fast scrolling.
    let scrollTimeout;
    let rafTimeout;
    window.addEventListener(
      'scroll',
      function () {
        if (rafTimeout) window.cancelAnimationFrame(rafTimeout);
        if (scrollTimeout) clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(function () {
          rafTimeout = window.requestAnimationFrame(checkFooterOverlap);
        }, 50);
      },
      { passive: true }
    );
    window.addEventListener('resize', checkFooterOverlap, { passive: true });
    checkFooterOverlap();

    // Hide sticky ATC when offcanvas menu opens
    const offcanvasMenu = document.getElementById('offcanvas-menu');
    if (offcanvasMenu) {
      offcanvasMenu.addEventListener('show.bs.offcanvas', function () {
        stickyAtc.style.display = 'none';
      });

      offcanvasMenu.addEventListener('hide.bs.offcanvas', function () {
        stickyAtc.style.display = '';
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
